import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import slugify from 'react-slugify'

const CategoryGroup = ({ id, name, subcategories }) => {
  let removeCategories = process.env.REACT_APP_REMOVE_CATEGORIES ? process.env.REACT_APP_REMOVE_CATEGORIES.split(',') : []
  let removeSubcategories = process.env.REACT_APP_REMOVE_SUBCATEGORIES ? process.env.REACT_APP_REMOVE_SUBCATEGORIES.split(',') : []

  const getUrl = (categoryId, subcategoryId) => {
    switch (subcategoryId) {
      case 80:
        return '/mileage'
      case 72:
        return '/fuelcredit'
      case 73:
        return '/billpayment'
      case 90:
        return '/mobile-recharge'
      case 93:
        return '/checkout/points-purchase'
      default:
        return '/search?category=' + categoryId + '&subcategory=' + subcategoryId
    }
  }
  if (removeCategories.includes(slugify(name, { delimiter: '-' }))) {
    return (<div />)
  }
  return (
    <div className={`CategoryGroup col-12 pb-3 ${slugify(name, { delimiter: '-' })}`} data-path={`/search?category=${id}`}>
      <h4 className='CategoryParent mb-1'>
        <Link
          to={`/search?category=${id}`}
          className='txt-font-body color-ui-1 h4'
        >
          {name}
        </Link>
      </h4>
      <div className='CategoryChilds row'>
        {
          subcategories.map((item, ix) => {
            if (!removeSubcategories.includes(slugify(item.name, { delimiter: '-' }))) {
              return (<div className={`col-12 col-md-4 pt-half pl-3 pl-md-1 ${slugify(item.name, { delimiter: '-' })}`}>
                <p>
                  <Link
                    key={ix}
                    to={getUrl(id, item.id)}
                    className={`txt-body-sm color-ui-1`}
                  >
                    {item.name}
                  </Link>
                </p>
              </div>)
            } else {
              return (<div />)
            }
          })}
      </div>
    </div>
  )
}

CategoryGroup.propTypes = {
  id: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  subcategories: PropTypes.array.isRequired
}
export default CategoryGroup



// WEBPACK FOOTER //
// ./src/features/ProductCategory/CategoryGroup.js